import { Stack } from '@mui/material';
import InvestmentSummary from './InvestmentSummary';
import InvestmentOverview from './InvestmentOverview';
import InvestmentStatus from './InvestmentStatus';
import InvestmentActions from './InvestmentActions';
import InvestmentStatusDetails from './InvestmentStatusDetails';
import { usePdpInfo } from '@/api/hooks/usePdpInfo';
const InvestmentDetails = ({
  hasDetail
}: {
  hasDetail?: boolean;
}) => {
  const {
    data
  } = usePdpInfo();
  return <Stack sx={{
    width: '100%',
    maxWidth: {
      md: 389,
      xs: 'unset'
    },
    bgcolor: 'background.bg',
    alignItems: 'center',
    borderRadius: 'var(--corner_radius_m)',
    position: {
      md: 'sticky',
      xs: 'unset'
    },
    top: '70px',
    overflow: 'hidden',
    boxShadow: '0px 0px 2px 0px rgba(0, 26, 63, 0.20), 0px 4px 10px 0px rgba(0, 26, 63, 0.10)',
    height: 'fit-content',
    mx: 'auto'
  }} data-sentry-element="Stack" data-sentry-component="InvestmentDetails" data-sentry-source-file="InvestmentDetails.tsx">
      <InvestmentOverview data={data} hasDetail={hasDetail} data-sentry-element="InvestmentOverview" data-sentry-source-file="InvestmentDetails.tsx" />
      <Stack sx={{
      alignItems: 'center',
      gap: 'var(--spacing_m)',
      width: '100%'
    }} data-sentry-element="Stack" data-sentry-source-file="InvestmentDetails.tsx">
        <InvestmentStatus data={data} data-sentry-element="InvestmentStatus" data-sentry-source-file="InvestmentDetails.tsx" />
        <Stack sx={{
        alignItems: 'center',
        px: 'var(--spacing_m)',
        pb: 'var(--spacing_m)',
        gap: 'var(--spacing_m)',
        width: '100%'
      }} data-sentry-element="Stack" data-sentry-source-file="InvestmentDetails.tsx">
          <InvestmentStatusDetails data={data} data-sentry-element="InvestmentStatusDetails" data-sentry-source-file="InvestmentDetails.tsx" />
          <InvestmentSummary data={data} data-sentry-element="InvestmentSummary" data-sentry-source-file="InvestmentDetails.tsx" />
          <InvestmentActions data={data} data-sentry-element="InvestmentActions" data-sentry-source-file="InvestmentDetails.tsx" />
        </Stack>
      </Stack>
    </Stack>;
};
export default InvestmentDetails;